import React, { useState } from 'react'
import Form from 'react-bootstrap/Form'
import InputGroup from 'react-bootstrap/InputGroup'
import cn from 'classnames'

const PasswordShowHide = (props) => {
  const [inputType, setinputType] = useState('password')

  const handleClick = (e) => {
    e.preventDefault()

    const eyeIcon = e.target

    if (inputType === 'password') {
      setinputType('text')
      eyeIcon.className = 'fa fa-eye'
    } else {
      setinputType('password')
      eyeIcon.className = 'fa fa-eye-slash'
    }
  }

  return (
    <div className={cn('form-group', props.wrapperClassName)}>
      <Form.Label htmlFor={props.name} className='control-label'>{props.label}</Form.Label>

      <InputGroup id='show_hide_password'>
        <Form.Control
          type={inputType}
          name={props.name}
          autoComplete={props.autocomplete || 'one-time-code'}
          readOnly={props.readonly || false}
          id={props.name}
          defaultValue={props.value}
          onChange={props.onChange}
        />

        <div className='input-group-addon'>
          <a href='' onClick={handleClick} className='fa fa-eye-slash' />
        </div>
      </InputGroup>
    </div>
  )
}

export default PasswordShowHide
